var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 21",
    style: {
      enableBackground: "new 0 0 21 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FF4A6B;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,1.6c-1.3-0.7-2.7-1.1-4-1.1s-2.7,0.4-4,1.1v9.9c1.3-0.7,2.7-1,4-1s2.7,0.3,4,1V1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,2.8c-0.7-0.2-1.4-0.3-2.1-0.3s-1.4,0.1-2.1,0.3 M14.6,4.8c-0.7-0.2-1.4-0.3-2.1-0.3s-1.4,0.1-2.1,0.3  M14.6,6.8c-0.7-0.2-1.4-0.3-2.1-0.3s-1.4,0.1-2.1,0.3 M14.6,8.8c-0.7-0.2-1.4-0.3-2.1-0.3s-1.4,0.1-2.1,0.3 M6.6,2.8 C5.9,2.6,5.2,2.5,4.5,2.5S3.1,2.6,2.4,2.8 M6.6,4.8C5.9,4.6,5.2,4.5,4.5,4.5S3.1,4.6,2.4,4.8 M6.6,6.8C5.9,6.6,5.2,6.5,4.5,6.5 S3.1,6.6,2.4,6.8 M6.6,8.8C5.9,8.6,5.2,8.5,4.5,8.5S3.1,8.6,2.4,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,1.6c-1.3-0.7-2.7-1.1-4-1.1s-2.7,0.4-4,1.1v9.9c1.3-0.7,2.7-1,4-1s2.7,0.3,4,1V1.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.4f12e09440380a2dc92e18492aef7bf2.svg";
export { ForwardRef as ReactComponent };